module.exports = __webpack_public_path__ + "static/media/dop-amza.1fc05f8b.svg";